import { RelatedBadges } from "./RelatedBadges";
import { buildRelatedUrl, pluralizeAsins } from "../relatedLinks";

// Attached to each inventory row by the inventoryTable lambda on every read.
// Counts are distinct non-merchant ASINs, matching what each badge's panel shows.
export interface RelatedInventory {
  equal_count: number;
  equal_product_ids: number[];
  shared_count: number;
  shared_product_ids: number[];
}

export function RelatedInventoryCell({
  inventoryId,
  related,
}: {
  inventoryId?: number | null;
  related?: RelatedInventory | null;
}) {
  if (inventoryId === null || inventoryId === undefined || !related) {
    return null;
  }

  // Both badges show this part in the inventory panel
  const { equal_count, equal_product_ids, shared_count, shared_product_ids } =
    related;

  return (
    <RelatedBadges
      equal={{
        count: equal_count,
        href: buildRelatedUrl({
          productIds: equal_product_ids,
          inventoryIds: [inventoryId],
        }),
        tooltip: `Equal: ${pluralizeAsins(
          equal_count
        )} of products made of only this part`,
      }}
      shared={{
        count: shared_count,
        href: buildRelatedUrl({
          productIds: shared_product_ids,
          inventoryIds: [inventoryId],
        }),
        tooltip: `Shared: ${pluralizeAsins(
          shared_count
        )} of every product that uses this part`,
      }}
    />
  );
}
